import Modal from "./Modal";
import Acknowledger from "./Acknowledger";

export default {
  Modal,
  Acknowledger
};
